import React, { useState, useEffect } from 'react'
import { useRouter } from 'next/router'

import DistanceDropdownUI from './DistanceDropdownUI'

interface DistanceDropdownProps {
  initialValue: number | undefined
  onDistanceChange: (distance: number) => void
}

const DistanceDropdown: React.FC<DistanceDropdownProps> = ({
  initialValue,
  onDistanceChange
}) => {
  const [selectedDistance, setSelectedDistance] = useState<number | undefined>(
    initialValue ?? undefined
  )
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const router = useRouter()

  const distanceOptions = [0.5, 2, 5, 10, 15, 25, 50, 100]

  const handleDropdownToggle = () => {
    setIsDropdownOpen(!isDropdownOpen)
  }

  const handleOptionSelect = (distance: number) => {
    setSelectedDistance(distance)
    onDistanceChange(distance * 1000)
    setIsDropdownOpen(false)

    const newQuery = { ...router.query, radius: distance * 1000 }
    router.push({ pathname: router.pathname, query: newQuery }, undefined, {
      shallow: true
    })
  }

  useEffect(() => {
    setSelectedDistance(
      router.query.radius === undefined
        ? undefined
        : parseInt(router.query.radius as string) / 1000
    )
  }, [router.query.radius])

  return (
    <DistanceDropdownUI
      selectedDistance={selectedDistance}
      isDropdownOpen={isDropdownOpen}
      distanceOptions={distanceOptions}
      handleDropdownToggle={handleDropdownToggle}
      handleOptionSelect={handleOptionSelect}
    />
  )
}

export default DistanceDropdown
